import { styled } from "@mui/material"
import { CustomerSearchComponent } from "./CustomerSearchComponent"

export const CustomerSearch = styled(CustomerSearchComponent, {
    name: "CustomerSearch",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})({})
